<template>
  <v-container>
    <v-toolbar class="mb-10" elevation="0">
      <v-toolbar-title>
        Dispositivos autorizados
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="loadData()" icon>
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card
      v-for="device in devices"
      :key="device.id"
      class="mt-2"
      elevation="0"
    >
      <v-card-title>
        <v-icon left>mdi-tablet-cellphone</v-icon> {{ device.name }}
      </v-card-title>
      <v-card-subtitle>
        #{{ device.id }}
        <span class="ml-1" v-if="isActualDevice(device.id)"
          >Dispositivo atual</span
        >
      </v-card-subtitle>

      <v-card-actions v-if="!device.authorized">
        <v-btn
          @click="handleApprove(device)"
          color="primary"
          small
          elevation="0"
          class="mr-1"
        >
          Aprovar
        </v-btn>

        <v-btn
          @click="handleReprove(device)"
          color="red"
          small
          dark
          elevation="0"
        >
          Reprovar
        </v-btn>
      </v-card-actions>

      <v-card-actions v-else-if="!isActualDevice(device.id)">
        <v-btn
          @click="handleRemoveDevice(device)"
          color="red"
          small
          dark
          elevation="0"
        >
          Remover acesso
        </v-btn>
      </v-card-actions>
    </v-card>

    <BottomSheet ref="sheet"></BottomSheet>
  </v-container>
</template>

<script>
import { authorize, index, destroy } from "../services/authorized_devices";
import BottomSheet from "@/components/BottomSheet.vue";

export default {
  components: { BottomSheet },

  data() {
    return {
      devices: [],
      loading: false
    };
  },

  methods: {
    handleApprove(device) {
      this.$refs.sheet.open("Confirmar aprovação?", [
        {
          icon: "mdi-check",
          title: "Aprovar",
          action: async () => {
            await authorize(device.id);
            this.loadData();
          }
        },
        {
          icon: "mdi-close",
          title: "Cancelar"
        }
      ]);
    },

    isActualDevice(deviceId) {
      const id = localStorage.getItem("device_id");

      return id == deviceId;
    },

    handleReprove(device) {
      this.$refs.sheet.open("Confirmar reprovação?", [
        {
          icon: "mdi-cancel",
          title: "Reprovar",
          action: async () => {
            await destroy(device.id);
            this.loadData();
          }
        },
        {
          icon: "mdi-close",
          title: "Cancelar"
        }
      ]);
    },

    handleRemoveDevice(device) {
      this.$refs.sheet.open("Remover acesso do dispositivo?", [
        {
          icon: "mdi-cancel",
          title: "Remover acesso",
          action: async () => {
            await destroy(device.id);
            this.loadData();
          }
        },
        {
          icon: "mdi-close",
          title: "Cancelar"
        }
      ]);
    },

    async loadData() {
      this.loading = true;

      try {
        this.devices = await index();
      } catch (error) {
        console.error(error);
        this.$store.commit("sendMessage", {
          text: "Erro inesperado, por favor tente mais tarde",
          color: "red"
        });
      } finally {
        this.loading = false;
      }
    }
  },

  created() {
    this.loadData();
  }
};
</script>
